module.exports = __webpack_public_path__ + "static/media/J. Storm Thurmond - 1948.e83c8bc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/J. Storm Thurmond - 1948.jpg
// module id = 496
// module chunks = 0